import styled from 'styled-components'
import { media } from '~/styles/variables'

export const MainContainer = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;

  ${media.sm}{
    flex-direction: row;
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
  padding: 30px;
  background: ${props => props.bg ? props.bg : '#FFFFFF'};

  ${media.sm}{
    height: 100vh;
    flex: 1;
    padding: 0 15px;
  }
`;
export const BackButton = styled.a`
  display: inline-flex;
  margin-bottom: 30px;
  color: #FFFFFF !important;
  font-size: 12px;
  font-weight: 700;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px;
  line-height: 1;
  z-index: 2;

  ${media.sm}{
    position: absolute;
    top: 54px;
    left: 46px;
  }

  img{
    font-weight: 400;
    margin-right: 10px
  }

  &:hover{
    text-decoration: underline;
  }
`;
export const Logo = styled.img`
  max-width: 100%;
  width: 200px;
`;
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.85);
  display: flex; justify-content: center; align-items: center;
  z-index: 9999; padding: 20px;
`;

export const ModalContainer = styled.div`
  background-color: #fff;
  padding: 40px;
  border-radius: 12px;
  max-width: 450px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0,0,0,0.5);
`;

export const ButtonActive = styled.button`
  padding: 15px 25px;
  font-size: 18px;
  font-weight: bold;
  background-color: #008338;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(1.2);
  }
`;

export const ButtonNormal = styled.button`
  padding: 12px 20px;
  font-size: 16px;
  background-color: #e9ecef;
  color: #333;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9); 
  }

`;